var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _g3, _path19, _path20, _g4, _path21, _path22, _g5, _path23, _path24, _g6, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOsmosisOsmoLogo = function SvgOsmosisOsmoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.913 11.037c-.395-1.562-1.687-3.123-4.001-4.86C36.052 4.79 34.084 4 32.512 4c-.317 0-.597.03-.886.088-.714.146-1.34.673-1.745 1.474-.482.946-.598 2.205-.29 2.976.116.235.26.527.425.79-1.514.947-2.372 1.211-2.488 1.24 3.944 1.357 7.231 4.187 9.285 7.867l.029-.352c.086-.976.376-2.088.771-3.24.395.117.8.176 1.196.176 1.06 0 1.966-.44 2.545-1.24.569-.79.8-1.854.54-2.742h.019Z",
    fill: "#5E12A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.796 13.984c2.603.732 3.654-1.327 3.317-2.713-.376-1.386-1.572-2.801-3.683-4.392-2.112-1.59-4.262-2.235-5.63-1.942-1.37.293-1.774 2.44-1.428 3.27.145.322.454.79.887 1.327-.54.38-1.06.673-1.484.946a17.048 17.048 0 0 1 6.633 5.446c.202-.79.482-1.503.742-2.117.203.029.424.087.656.175h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 42.844c8.822 0 15.976-7.369 15.976-16.465S31.732 9.924 22.91 9.924c-8.821 0-15.965 7.369-15.965 16.455 0 9.086 7.153 16.465 15.975 16.465h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.801 9.924c-2.169-2.352-4-2.977-6.199-3.474-1.716-.41-1.253-1.415.83-1.21-1.003-.352-1.948-.44-2.633-.293-1.369.292-1.773 2.44-1.427 3.27.145.321.454.79.887 1.327-.77.527-1.426.917-1.966 1.21.26.117.569.263.945.468.973.527 2.024 1.415 2.024 1.415-1.6-1.415-1.253-2.059.945-3.65.684-.498 1.947-.439 3.114.176 1.176.615 2.545 2.176 2.545 2.176l-1.31 2.596.26.088c.828.235 1.484.176 1.995-.029.598-.38 2.17-1.679 0-4.06l-.01-.01Z",
    fill: "#A98698"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.573 7.855c.57.234 1.312.644 2.227 1.269a16.134 16.134 0 0 1 2.633 2.206c-1.003 1.356-1.659 3.21-2.054 4.509.202.292.424.585.627.888.202-.732.54-1.825 1.002-2.918.116.029.26.029.395.029.348 0 .743-.059 1.061-.322.231-.176.482-.498.453-1.093 0-.557-.424-1.27-1.311-2.118-.627-.615-1.485-1.298-2.343-1.913-2.458-1.679-4.174-2.147-4.946-1.357-.51.527-.453 1.181-.289 1.65a35.401 35.401 0 0 1-2.198 1.356c.347.117.656.264 1.003.41.916-.498 2.227-1.356 3.74-2.596Zm5.4 4.216a.794.794 0 0 1 .115.381c0 .264-.087.351-.145.41-.115.088-.347.146-.54.146.174-.351.377-.644.57-.946v.01ZM31.914 7.68c.087-.087.318-.146.685-.087-.29.234-.57.439-.858.644-.03-.205 0-.41.173-.557Z",
    fill: "#5E12A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 8.948C13.568 8.948 6 16.756 6 26.38c0 9.623 7.568 17.44 16.91 17.44 9.343 0 16.91-7.807 16.91-17.44 0-9.633-7.596-17.43-16.91-17.43Zm0 33.896c-8.821 0-15.965-7.359-15.965-16.465S14.089 9.924 22.91 9.924c8.822 0 15.976 7.36 15.976 16.465 0 9.106-7.173 16.465-15.976 16.465v-.01Z",
    fill: "#5E12A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.91 42.844c8.822 0 15.976-7.369 15.976-16.465S31.732 9.924 22.91 9.924c-8.821 0-15.965 7.369-15.965 16.455 0 9.086 7.153 16.465 15.975 16.465h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.804 40.843C14.09 39.4 8.18 30.947 9.606 21.968c.626-3.973 2.574-7.36 5.312-9.809-4.001 2.382-6.97 6.54-7.77 11.605-1.399 8.979 4.511 17.44 13.198 18.875 4.859.82 9.544-.732 12.996-3.797a15.587 15.587 0 0 1-10.547 2.001h.01Z",
    fill: "#A98698"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.456 10.158c-4.03-.673-7.945.264-11.146 2.353l-.115.117c1.224-.762 3.027-1.445 3.027-1.445-4.628 2.772-6.054 5.924-6.054 5.924 1.802-3.591 7.086-6.129 11.231-6.304 4.146-.176 6.855 1.093 10.172 3.825 3.316 2.772 5.312 8.423 5.11 12.903-.174 4.48-2.459 8.1-2.459 8.1 1.571-2.088 2.516-3.62 3.114-5.182.116-.469.231-.947.29-1.444 1.426-8.95-4.455-17.402-13.17-18.847Z",
    fill: "url(#osmosis-osmo-logo_svg__d)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.085 26.233c0 8.627-6.797 15.635-15.175 15.635S7.716 34.87 7.716 26.233h30.37Z",
    fill: "url(#osmosis-osmo-logo_svg__e)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.89 26.233c0 8.423-6.46 15.313-14.568 15.635h.598c8.368 0 15.175-7.008 15.175-15.635H36.89Z",
    fill: "url(#osmosis-osmo-logo_svg__f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.856 26.233h-2.14c0 8.627 6.797 15.635 15.175 15.635.376 0 .714 0 1.06-.03-7.857-.585-14.085-7.358-14.085-15.605h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__g)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.056 26.38c0-1.797-3.027-2.831-7.057-3.182-2.911-.235-5.862.058-9.226 1.122-2.912.888-5.544.732-7.453.498-4.261-.498-6.604-.557-6.604 1.561 0 3.065 6.055 6.89 15.146 5.563 4.599-.673 6.97-2.06 9.69-3.006 2.94-1.005 5.514-.976 5.514-2.567l-.01.01Z",
    fill: "url(#osmosis-osmo-logo_svg__h)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.885 18.962c1.417 0 2.574-1.19 2.574-2.655 0-1.464-1.147-2.655-2.574-2.655-1.427 0-2.574 1.191-2.574 2.655 0 1.464 1.147 2.655 2.574 2.655ZM32.089 20.933c.597 0 1.09-.497 1.09-1.122 0-.625-.483-1.122-1.09-1.122-.608 0-1.09.497-1.09 1.122 0 .625.482 1.122 1.09 1.122Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.974 14.19h-.058c-.173-.03-.29-.206-.26-.41.26-1.357 1.34-2.655 1.398-2.714.115-.146.347-.146.453-.03a.331.331 0 0 1 .029.47c-.03.028-1.032 1.239-1.254 2.41a.31.31 0 0 1-.318.263l.01.01Z",
    fill: "url(#osmosis-osmo-logo_svg__i)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.86 38.667c.443 0 .8-.371.8-.82 0-.449-.357-.83-.8-.83-.444 0-.8.371-.8.83 0 .459.356.82.8.82Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.397 38.374a.85.85 0 0 1 0-1.181c.058-.058.115-.088.173-.146a.599.599 0 0 0-.289.175.85.85 0 0 0 0 1.181c.26.264.656.322.974.147a.785.785 0 0 1-.858-.176Z",
    fill: "url(#osmosis-osmo-logo_svg__j)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.14 37.603a.174.174 0 0 0 .173-.176.174.174 0 1 0-.347 0c0 .098.077.176.173.176Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.034 38.257c.444 0 .8-.371.8-.82 0-.449-.356-.83-.8-.83-.443 0-.8.371-.8.83 0 .459.357.82.8.82Z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.571 37.964a.85.85 0 0 1 0-1.18c.058-.06.116-.089.174-.147a.599.599 0 0 0-.29.175.85.85 0 0 0 0 1.181c.26.264.656.322.974.147a.785.785 0 0 1-.858-.176Z",
    fill: "url(#osmosis-osmo-logo_svg__k)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.314 37.193a.174.174 0 0 0 .173-.176.174.174 0 1 0-.347 0c0 .098.077.176.174.176Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.97 40.17a.607.607 0 0 0 .599-.615.607.607 0 0 0-.598-.615.607.607 0 0 0-.598.615c0 .342.27.615.598.615Z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.624 39.935a.655.655 0 0 1 0-.888c.029-.029.087-.058.116-.087a.655.655 0 0 0-.203 1.035c.203.204.482.233.742.087a.608.608 0 0 1-.655-.147Z",
    fill: "url(#osmosis-osmo-logo_svg__l)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.173 39.34a.112.112 0 0 0 .116-.117.112.112 0 0 0-.116-.117.112.112 0 0 0-.115.117c0 .068.048.117.115.117Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.654 39.73a.607.607 0 0 0 .598-.614.607.607 0 0 0-.598-.615.607.607 0 0 0-.598.615c0 .341.27.615.598.615Z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.316 39.487a.655.655 0 0 1 0-.889c.03-.029.087-.058.116-.087a.52.52 0 0 0-.202.146.655.655 0 0 0 0 .888c.202.205.482.234.742.088a.608.608 0 0 1-.656-.146Z",
    fill: "url(#osmosis-osmo-logo_svg__m)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.856 38.901a.112.112 0 0 0 .116-.117.112.112 0 0 0-.116-.117.112.112 0 0 0-.116.117c0 .068.049.117.116.117Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.456 38.374c.723 0 1.311-.605 1.311-1.357 0-.751-.588-1.356-1.31-1.356-.724 0-1.312.605-1.312 1.356 0 .752.588 1.357 1.311 1.357Z",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.714 37.867a1.385 1.385 0 0 1 0-1.913c.087-.088.173-.147.29-.205-.174.058-.319.175-.454.292a1.385 1.385 0 0 0 0 1.913c.424.44 1.09.527 1.6.205-.482.205-1.06.117-1.426-.292h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__n)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.91 36.608c.154 0 .289-.137.289-.293a.292.292 0 0 0-.29-.293.292.292 0 0 0-.289.293c0 .156.125.293.29.293Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.199 35.046c.723 0 1.311-.605 1.311-1.357 0-.751-.588-1.356-1.311-1.356s-1.311.605-1.311 1.356c0 .752.588 1.357 1.311 1.357Z",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.428 34.538a1.385 1.385 0 0 1 0-1.912 1.04 1.04 0 0 1 .289-.206c-.174.06-.318.176-.453.293a1.385 1.385 0 0 0 0 1.913c.424.44 1.09.527 1.6.205a1.257 1.257 0 0 1-1.427-.293h-.01Z",
    fill: "url(#osmosis-osmo-logo_svg__o)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.652 33.28c.154 0 .29-.137.29-.294a.292.292 0 0 0-.29-.292.292.292 0 0 0-.29.292c0 .157.126.293.29.293Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__c",
    x1: 20.269,
    y1: 42.62,
    x2: 25.689,
    y2: 10.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__d",
    x1: 34.316,
    y1: 15.37,
    x2: 20.739,
    y2: 27.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__e",
    x1: 7.716,
    y1: 34.06,
    x2: 38.085,
    y2: 34.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0002E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__f",
    x1: 39.599,
    y1: 27.697,
    x2: 22.604,
    y2: 43.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__g",
    x1: 7.716,
    y1: 34.06,
    x2: 23.942,
    y2: 34.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__h",
    x1: 7.745,
    y1: 27.677,
    x2: 38.056,
    y2: 27.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__i",
    x1: 37.603,
    y1: 10.949,
    x2: 35.327,
    y2: 14.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__j",
    x1: 21.05,
    y1: 37.847,
    x2: 22.255,
    y2: 37.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__k",
    x1: 25.215,
    y1: 37.437,
    x2: 26.429,
    y2: 37.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__l",
    x1: 23.363,
    y1: 39.565,
    x2: 24.279,
    y2: 39.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__m",
    x1: 27.037,
    y1: 39.126,
    x2: 27.953,
    y2: 39.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__n",
    x1: 17.145,
    y1: 37.056,
    x2: 19.122,
    y2: 37.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "osmosis-osmo-logo_svg__o",
    x1: 28.869,
    y1: 33.728,
    x2: 30.845,
    y2: 33.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "osmosis-osmo-logo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.7744 0 0 13.1659 39.199 8.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "osmosis-osmo-logo_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.6233 0 0 16.1036 32.287 14.745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })))));
};
export { SvgOsmosisOsmoLogo as ReactComponent };